import { DiscountEditorRoot } from 'modules/Cube/view/common/drawers/discountEditor/drawer/content/DiscountEditorRoot'
import { useDiscountEditorConnector } from 'modules/Cube/view/common/drawers/discountEditor/useDiscountEditor.connector'

export const DiscountEditorCubeRoute = () => {
  const billingScheduleDiscountContext = useDiscountEditorConnector()

  return <DiscountEditorRoot {...billingScheduleDiscountContext} />
}
